/**
 * @generated SignedSource<<7127b9bf16d7dbaecef36f98ed022a99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSimilarSoldItemsColumn_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSimilarSoldItemsTracking_viewer">;
  readonly " $fragmentType": "PdpSharedSimilarSoldItemsColumn_viewer";
};
export type PdpSharedSimilarSoldItemsColumn_viewer$key = {
  readonly " $data"?: PdpSharedSimilarSoldItemsColumn_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumn_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSimilarSoldItemsColumn_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSimilarSoldItemsTracking_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "99d620b5c032287a9e9ddb0e2e237407";

export default node;
